/**
 * 로그인 사용자에 묶인 모듈 캐시를 로그아웃 때 함께 비운다(D-213).
 * 캐시를 가진 모듈이 onSessionClear 로 비우는 함수를 등록하고, 인증 저장소 clear() 가 clearSessionCaches() 를 부른다.
 * 이 파일은 다른 모듈을 불러오지 않는다 - 인증 저장소와 업무 서비스 사이에 순환 참조가 생기지 않게.
 */
const clearers = new Set();

export function onSessionClear(fn) {
  clearers.add(fn);
}

export function clearSessionCaches() {
  clearers.forEach((fn) => {
    try {
      fn();
    } catch {
      /* 하나가 실패해도 나머지는 비운다 */
    }
  });
}
